/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Suggestedoffers_Title1Inputs */

const id_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda mungkin juga suka`)
};

const ms_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda mungkin juga suka`)
};

const da_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du vil måske også kunne lide`)
};

const de_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das könnte Ihnen auch gefallen`)
};

const en_us2_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may also like`)
};

const es_es2_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`También te puede gustar`)
};

const es_mx2_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`También te puede gustar`)
};

const fil_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaari mo ring magustuhan`)
};

const fr_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pourriez aussi aimer`)
};

const it_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrebbe piacerti anche`)
};

const hu_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez is érdekelhet`)
};

const nl_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit vind je misschien ook leuk`)
};

const no_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du liker kanskje også`)
};

const pl_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Może Ci się również spodobać`)
};

const pt_br2_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may also like`)
};

const pt_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Também pode gostar`)
};

const ro_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ți-ar putea plăcea și`)
};

const fi_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatat myös pitää`)
};

const sv_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kanske också gillar`)
};

const vi_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn cũng có thể thích`)
};

const tr_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunlar da ilginizi çekebilir`)
};

const cs_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mohlo by se vám také líbit`)
};

const bg_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Може също да харесате`)
};

const ru_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вам также может понравиться`)
};

const uk_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вам також може сподобатися`)
};

const ar_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قد يعجبك أيضًا`)
};

const hi_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको ये भी पसंद आ सकते हैं`)
};

const th_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณอาจจะชอบ`)
};

const ja_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたへのおすすめ`)
};

const zh_cn2_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may also like`)
};

const zh_hant1_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may also like`)
};

const ko_components_suggestedoffers_title1 = /** @type {(inputs: Components_Suggestedoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may also like`)
};

/**
* | output |
* | --- |
* | "You may also like" |
*
* @param {Components_Suggestedoffers_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_suggestedoffers_title1 = /** @type {((inputs?: Components_Suggestedoffers_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Suggestedoffers_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_suggestedoffers_title1(inputs)
	if (locale === "ms") return ms_components_suggestedoffers_title1(inputs)
	if (locale === "da") return da_components_suggestedoffers_title1(inputs)
	if (locale === "de") return de_components_suggestedoffers_title1(inputs)
	if (locale === "en-US") return en_us2_components_suggestedoffers_title1(inputs)
	if (locale === "es-ES") return es_es2_components_suggestedoffers_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_suggestedoffers_title1(inputs)
	if (locale === "fil") return fil_components_suggestedoffers_title1(inputs)
	if (locale === "fr") return fr_components_suggestedoffers_title1(inputs)
	if (locale === "it") return it_components_suggestedoffers_title1(inputs)
	if (locale === "hu") return hu_components_suggestedoffers_title1(inputs)
	if (locale === "nl") return nl_components_suggestedoffers_title1(inputs)
	if (locale === "no") return no_components_suggestedoffers_title1(inputs)
	if (locale === "pl") return pl_components_suggestedoffers_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_suggestedoffers_title1(inputs)
	if (locale === "pt") return pt_components_suggestedoffers_title1(inputs)
	if (locale === "ro") return ro_components_suggestedoffers_title1(inputs)
	if (locale === "fi") return fi_components_suggestedoffers_title1(inputs)
	if (locale === "sv") return sv_components_suggestedoffers_title1(inputs)
	if (locale === "vi") return vi_components_suggestedoffers_title1(inputs)
	if (locale === "tr") return tr_components_suggestedoffers_title1(inputs)
	if (locale === "cs") return cs_components_suggestedoffers_title1(inputs)
	if (locale === "bg") return bg_components_suggestedoffers_title1(inputs)
	if (locale === "ru") return ru_components_suggestedoffers_title1(inputs)
	if (locale === "uk") return uk_components_suggestedoffers_title1(inputs)
	if (locale === "ar") return ar_components_suggestedoffers_title1(inputs)
	if (locale === "hi") return hi_components_suggestedoffers_title1(inputs)
	if (locale === "th") return th_components_suggestedoffers_title1(inputs)
	if (locale === "ja") return ja_components_suggestedoffers_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_suggestedoffers_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_suggestedoffers_title1(inputs)
	return ko_components_suggestedoffers_title1(inputs)
});
export { components_suggestedoffers_title1 as "components.suggestedOffers.title" }